var __assign = function() {
  __assign = Object.assign || function __assign(t) {
      for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];
          for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
      return t;
  };
  return __assign.apply(this, arguments);
};
function __spreadArray(to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
      if (ar || !(i in from)) {
          if (!ar) ar = Array.prototype.slice.call(from, 0, i);
          ar[i] = from[i];
      }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
}
typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
  var e = new Error(message);
  return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

// 网络类型定义
var NetType;
(function (NetType) {
    NetType[NetType["WIFI"] = 1] = "WIFI";
    NetType[NetType["2G"] = 2] = "2G";
    NetType[NetType["3G"] = 3] = "3G";
    NetType[NetType["4G"] = 4] = "4G";
    NetType[NetType["5G"] = 5] = "5G";
    NetType[NetType["MOBILE"] = 6] = "MOBILE";
    NetType[NetType["ETHERNET"] = 7] = "ETHERNET";
    NetType[NetType["OTHER"] = 8] = "OTHER";
})(NetType || (NetType = {}));
// 事件类型定义
var EventType;
(function (EventType) {
    EventType[EventType["EXPOSE"] = 1001] = "EXPOSE";
    EventType[EventType["CLICK"] = 1002] = "CLICK";
    EventType[EventType["EXIT"] = 1003] = "EXIT";
    EventType[EventType["DELETE"] = 1004] = "DELETE";
    EventType[EventType["ADD"] = 1005] = "ADD";
    EventType[EventType["MOVE"] = 1006] = "MOVE";
})(EventType || (EventType = {}));
// 系统类型定义
var SysId;
(function (SysId) {
    SysId[SysId["ANDROID"] = 1] = "ANDROID";
    SysId[SysId["IOS"] = 2] = "IOS";
    SysId[SysId["PC"] = 3] = "PC";
})(SysId || (SysId = {}));
var ProductId;
(function (ProductId) {
    ProductId[ProductId["XINYUE"] = 1] = "XINYUE";
    ProductId[ProductId["XIAOYUE"] = 2] = "XIAOYUE";
    ProductId[ProductId["SVIP"] = 3] = "SVIP";
    ProductId[ProductId["CIEBA"] = 4] = "CIEBA";
    ProductId[ProductId["HELPER"] = 5] = "HELPER";
})(ProductId || (ProductId = {}));
var DataSource;
(function (DataSource) {
    DataSource[DataSource["NATIVE_APP"] = 1] = "NATIVE_APP";
    DataSource[DataSource["PC"] = 2] = "PC";
    DataSource[DataSource["INSIDE"] = 3] = "INSIDE";
    DataSource[DataSource["WECHART_OFFICIAL_WEBSITE"] = 4] = "WECHART_OFFICIAL_WEBSITE";
    DataSource[DataSource["H5_APP"] = 21] = "H5_APP";
    DataSource[DataSource["H5_MOBILE"] = 12] = "H5_MOBILE";
    DataSource[DataSource["H5_PC"] = 22] = "H5_PC";
    DataSource[DataSource["H5_WX_ACCOUNT"] = 11] = "H5_WX_ACCOUNT";
    DataSource[DataSource["H5_WX_MP"] = 23] = "H5_WX_MP";
    DataSource[DataSource["H5_QQ_ACCOUNT"] = 10] = "H5_QQ_ACCOUNT";
    DataSource[DataSource["H5_QQ_MP"] = 24] = "H5_QQ_MP";
    DataSource[DataSource["OTHER"] = 0] = "OTHER";
})(DataSource || (DataSource = {}));
// 登录类型
var LoginType;
(function (LoginType) {
    LoginType[LoginType["QQ"] = 1] = "QQ";
    LoginType[LoginType["WX"] = 2] = "WX";
    LoginType[LoginType["QC"] = 3] = "QC";
})(LoginType || (LoginType = {}));

// 生成用于测量时间差的时间，精确到毫秒
var measureTime = function () { var _a; return ((_a = performance === null || performance === void 0 ? void 0 : performance.now) === null || _a === void 0 ? void 0 : _a.call(performance)) || new Date().getTime(); };

// 监听 & 劫持history
var listenHistory = (function (callback) {
    var prev = __assign({}, window.location);
    // 监听history和hashchange
    window.addEventListener('popstate', function () {
        callback('exitPage', prev, null);
        var current = __assign({}, window.location);
        callback('enterPage', current, prev);
        prev = current;
    });
    // 劫持pushState
    var originPushState = window.history.pushState;
    window.history.pushState = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (args[2]) {
            prev = __assign({}, window.location);
            callback('exitPage', prev, null);
        }
        originPushState.call.apply(originPushState, __spreadArray([this], args, false));
        if (args[2]) {
            var current = __assign({}, window.location);
            callback('enterPage', current, prev);
            prev = current;
        }
    };
    // 劫持replaceState
    var originReplaceState = window.history.replaceState;
    window.history.replaceState = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (args[2]) {
            prev = __assign({}, window.location);
            callback('exitPage', prev, null);
        }
        originReplaceState.call.apply(originReplaceState, __spreadArray([this], args, false));
        if (args[2]) {
            var current = __assign({}, window.location);
            callback('enterPage', current, prev);
            prev = current;
        }
    };
});

var pluginPV = function (probe /* , options: any = {} */) {
    var enterPageTime = measureTime();
    var currentLocation = __assign({}, window.location); // 当前页面
    var prevLocation = null; // 前一个页面
    var enterPage = function (message) {
        probe.report(__assign({ event_type: EventType.EXPOSE, referrer: (prevLocation === null || prevLocation === void 0 ? void 0 : prevLocation.href) || null }, message));
    };
    // 退出页面
    var exitPage = function (message) {
        var staytime = measureTime() - enterPageTime;
        probe.report(__assign({ event_type: EventType.EXIT, url: (currentLocation === null || currentLocation === void 0 ? void 0 : currentLocation.href) || null, params: (currentLocation === null || currentLocation === void 0 ? void 0 : currentLocation.search.replace(/^\?/, '')) || '', referrer: (prevLocation === null || prevLocation === void 0 ? void 0 : prevLocation.href) || null, staytime: (staytime / 1000).toFixed(1) }, message));
    };
    // spa页面处理
    if (probe.options.spa) {
        listenHistory(function (type, current, prev) {
            var staytime = type === 'enterPage' ? 0 : measureTime() - enterPageTime;
            if (type === 'enterPage') {
                enterPageTime = measureTime(); // 修改进入页面时间
                currentLocation = current; // 修改当前页面
                prevLocation = prev; // 修改前一个页面
            }
            probe.emit(type, { type: type, current: current, prev: prev, staytime: staytime });
        });
    }
    // 初始化即认为是一次enterPage事件
    probe.on('ready', function () {
        probe.emit('enterPage', {
            type: 'enterPage',
            current: currentLocation,
            prev: null,
            staytime: 0,
        });
    });
    // 卸载页面时触发
    window.addEventListener('beforeunload', function () {
        var staytime = measureTime() - enterPageTime;
        probe.emit('exitPage', {
            type: 'exitPage',
            current: currentLocation,
            prev: null,
            staytime: staytime,
        });
    });
    // 暴露接口
    probe.expose('enterPage', enterPage);
    probe.expose('exitPage', exitPage);
};

export { pluginPV as default };
